var map = {
	"./404.svg": "8e71",
	"./arrow-right.svg": "3f8a",
	"./balkam-group/header.png": "6744",
	"./balkam-group/propr/1.jpg": "0cab",
	"./balkam-group/propr/2.jpg": "1242",
	"./balkam-group/propr/3.jpg": "7d0e",
	"./balkam-group/propr/4.jpg": "30eb",
	"./balkam-group/propr/5.jpg": "66f7",
	"./balkam-group/sert-mob.svg": "74bc",
	"./balkam-group/sertificati.svg": "a647",
	"./balkam-group/sust/1.jpg": "d897",
	"./balkam-group/sust/2.jpg": "f8aa",
	"./balkam-group/sust/3.jpg": "b81a",
	"./balkam-group/values.svg": "09e1",
	"./balkam-group/values_animated.svg": "8dae",
	"./balkam-group/weare/1.jpg": "f267",
	"./balkam-group/weare/2.jpg": "6b2d",
	"./balkam-group/weare/3.png": "afda",
	"./balkam-group/weare/4.png": "e678",
	"./beans-and-grinded/bags.png": "18f6",
	"./beans-and-grinded/coffee-beans-big.png": "2e88",
	"./beans-and-grinded/coffee-beans.png": "9920",
	"./beans-and-grinded/coffee-grinded.png": "dcb4",
	"./beans-and-grinded/soluble.png": "4554",
	"./blends/arabica-bean.png": "dc1a",
	"./blends/arabica-txt.svg": "c83e",
	"./blends/b1.png": "430e",
	"./blends/b2.png": "c010",
	"./blends/background.png": "6196",
	"./blends/header.png": "143e",
	"./blends/robusta-bean.png": "6405",
	"./blends/robusta-txt.svg": "13d5",
	"./brands/back.svg": "ca47",
	"./brands/balkam/1.png": "bf2a",
	"./brands/balkam/balkam-small.svg": "94ad",
	"./brands/balkam/balkam.svg": "c311",
	"./brands/balkam/map-balkam.svg": "10f8",
	"./brands/balkam/p1.png": "40e5",
	"./brands/balkam/p2.png": "361b",
	"./brands/balkam/p3.png": "61be",
	"./brands/balkam/p4.png": "0923",
	"./brands/balkam/p5.png": "c65d",
	"./brands/basilur/1.png": "87ba",
	"./brands/basilur/b1.png": "c7d8",
	"./brands/basilur/basilur-small.svg": "0ec9",
	"./brands/basilur/basilurr.svg": "8ac4",
	"./brands/basilur/p1.png": "16cc",
	"./brands/basilur/p2.png": "01be",
	"./brands/basilur/p3.png": "39ff",
	"./brands/basilur/p4.png": "f6ec",
	"./brands/basilur/p5.png": "5ed7",
	"./brands/basilur/p6.png": "ee5d",
	"./brands/basilur/p7.png": "229e",
	"./brands/basilur/p8.png": "6d73",
	"./brands/basilur/p9.png": "7b1b",
	"./brands/caprimo/1.png": "f98c",
	"./brands/caprimo/caprimo.png": "8884",
	"./brands/caprimo/caprimo.svg": "51ec",
	"./brands/caprimo/p1.png": "d025",
	"./brands/caprimo/p2.png": "b7c0",
	"./brands/caprimo/p3.png": "8da8",
	"./brands/caprimo/p4.png": "8a4f",
	"./brands/caprimo/p5.png": "1ca9",
	"./brands/caprimo/p6.png": "3208",
	"./brands/caprimo/p7.png": "6857",
	"./brands/caprimo/p8.png": "36c0",
	"./brands/greenIsland/1.png": "ea42",
	"./brands/greenIsland/greenIsland-small.svg": "26e7",
	"./brands/greenIsland/green_island.svg": "7857",
	"./brands/greenIsland/p1.png": "a131",
	"./brands/greenIsland/p10.png": "fab3",
	"./brands/greenIsland/p2.png": "5f8a",
	"./brands/greenIsland/p3.png": "4bc4",
	"./brands/greenIsland/p4.png": "d7d9",
	"./brands/greenIsland/p5.png": "e2f4",
	"./brands/greenIsland/p6.png": "9e2d",
	"./brands/greenIsland/p7.png": "5114",
	"./brands/greenIsland/p8.png": "1b59",
	"./brands/greenIsland/p9.png": "4196",
	"./brands/header.png": "70eb",
	"./brands/lavista/1.png": "8d83",
	"./brands/lavista/lavista-small.svg": "a0ff",
	"./brands/lavista/lavista.svg": "7773",
	"./brands/lavista/map-lavista.svg": "1d40",
	"./brands/lavista/p1.png": "30e7",
	"./brands/lavista/p2.png": "4bcd",
	"./brands/lavista/p3.png": "dfa4",
	"./brands/lavista/p4.png": "bb19",
	"./brands/lavista/p5.png": "4261",
	"./brands/maison/1.png": "ea28",
	"./brands/maison/m1-min.png": "4c33",
	"./brands/maison/maison-small.svg": "45a5",
	"./brands/maison/maison.svg": "a4b3",
	"./brands/maison/p1.png": "6cae",
	"./brands/maison/p2.png": "f828",
	"./brands/maison/p3.png": "586a",
	"./brands/maison/p4.png": "4c9b",
	"./brands/maison/p5.png": "1db2",
	"./brands/maison/p6.png": "1099",
	"./brands/napoli/1.png": "76ab",
	"./brands/napoli/map-napoli.svg": "d62b",
	"./brands/napoli/napoli-small.svg": "3449",
	"./brands/napoli/napoli.svg": "8841",
	"./brands/napoli/p1.png": "c8b7",
	"./brands/napoli/p2.png": "b73b",
	"./brands/napoli/p3.png": "ede9",
	"./brands/santos/1.png": "2578",
	"./brands/santos/map-santos.svg": "562a",
	"./brands/santos/p1.png": "e529",
	"./brands/santos/p2.png": "9eaf",
	"./brands/santos/p3.png": "779d",
	"./brands/santos/p4.png": "63ef",
	"./brands/santos/p5.png": "7ee9",
	"./brands/santos/p6.png": "8e40",
	"./brands/santos/p7.png": "f25f",
	"./brands/santos/santos-small.svg": "ce47",
	"./brands/santos/santos.svg": "f448",
	"./brands/spetema/1.png": "915b",
	"./brands/spetema/map-spetema.svg": "9260",
	"./brands/spetema/p0.png": "1ea8",
	"./brands/spetema/p1.png": "d091",
	"./brands/spetema/p2.png": "e3be",
	"./brands/spetema/p3.png": "7303",
	"./brands/spetema/p4.png": "56ed",
	"./brands/spetema/p5.png": "16ab",
	"./brands/spetema/p6.png": "f727",
	"./brands/spetema/p7.png": "e314",
	"./brands/spetema/p8.png": "47e7",
	"./brands/spetema/p9.png": "f519",
	"./brands/spetema/spetema-small.svg": "bd89",
	"./brands/spetema/spetema.svg": "ef89",
	"./brands/te/1.png": "1c40",
	"./brands/te/p1.png": "ac66",
	"./brands/te/p2.png": "57f3",
	"./brands/te/p3.png": "006c",
	"./brands/te/p4.png": "1049",
	"./brands/te/p5.png": "d86a",
	"./brands/te/p6.png": "6f4b",
	"./brands/te/t1-min.png": "6cd3",
	"./brands/te/te-small.svg": "8daa",
	"./brands/te/tee.svg": "fe15",
	"./brands/vanHouten/1.png": "7e55",
	"./brands/vanHouten/p1.png": "6738",
	"./brands/vanHouten/p2.png": "38ec",
	"./brands/vanHouten/vanHouten.png": "eb08",
	"./brands/vanHouten/vanHouten.svg": "7225",
	"./brands/verdico/1.png": "432c",
	"./brands/verdico/map-verdico.svg": "88ad",
	"./brands/verdico/p1.png": "4cad",
	"./brands/verdico/p2.png": "464d",
	"./brands/verdico/p3.png": "fb81",
	"./brands/verdico/p4.png": "806c",
	"./brands/verdico/p5.png": "338b",
	"./brands/verdico/verdico-small.svg": "dd33",
	"./brands/verdico/verdico.svg": "58e7",
	"./brands/world.svg": "b22a",
	"./capsules-and-pods/Dolce-Gusto/dg16.png": "05b1",
	"./capsules-and-pods/Dolce-Gusto/dg30.png": "8d03",
	"./capsules-and-pods/Dolce-Gusto/first-image.png": "5df7",
	"./capsules-and-pods/Dolce-Gusto/fourth-image.png": "78d5",
	"./capsules-and-pods/Dolce-Gusto/second-image.png": "33a4",
	"./capsules-and-pods/Dolce-Gusto/third-image.png": "85c1",
	"./capsules-and-pods/Ese/1-1.png": "4e73",
	"./capsules-and-pods/Ese/1-2.png": "bc5c",
	"./capsules-and-pods/Ese/1-3.png": "9528",
	"./capsules-and-pods/Ese/cup-and-pod.png": "32f7",
	"./capsules-and-pods/Ese/ese.png": "9637",
	"./capsules-and-pods/Ese/pod1.png": "5aa6",
	"./capsules-and-pods/Ese/pod2.png": "aac4",
	"./capsules-and-pods/Lavazza/first-picture.png": "f441",
	"./capsules-and-pods/Lavazza/l100.png": "11c6",
	"./capsules-and-pods/Lavazza/l16.png": "27df",
	"./capsules-and-pods/Lavazza/l50.png": "bfef",
	"./capsules-and-pods/Nespresso/nes1.png": "637d",
	"./capsules-and-pods/Nespresso/nes2.png": "b4e1",
	"./capsules-and-pods/dg.svg": "f027",
	"./capsules-and-pods/lb.svg": "59a2",
	"./capsules-and-pods/nes.svg": "217f",
	"./capsules-and-pods/partnership/bianci.png": "3e8f",
	"./capsules-and-pods/partnership/coffee-beans.png": "f765",
	"./capsules-and-pods/partnership/coffee-grinded.png": "9fed",
	"./capsules-and-pods/partnership/logo.svg": "eb62",
	"./capsules-and-pods/partnership/necta.png": "ff67",
	"./capsules-and-pods/partnership/packs.png": "916b",
	"./capsules-and-pods/partnership/soluble.png": "f833",
	"./capsules-and-pods/pod.svg": "7966",
	"./coffee-beans/1.png": "9302",
	"./coffee-beans/2.png": "688e",
	"./coffee-beans/3.png": "f64d",
	"./coffee-beans/coffee-beans.png": "781b",
	"./contacts/complete.svg": "5cba",
	"./contacts/header.png": "0a5d",
	"./contacts/hover.svg": "76eb",
	"./contacts/normal.svg": "355a",
	"./contacts/not-ready.svg": "9cad",
	"./contacts/ready.svg": "0082",
	"./contacts/uncomplete.svg": "fbe0",
	"./footer/address-bo.svg": "e27e",
	"./footer/address-sf.svg": "528d",
	"./footer/balkam-numbers.gif": "73e6",
	"./footer/map.jpg": "23bf",
	"./footer/numbers.png": "a59a",
	"./grinded/1.png": "20e2",
	"./grinded/2.png": "0821",
	"./grinded/3.png": "91e7",
	"./grinded/grinded.png": "88da",
	"./home/1.png": "2930",
	"./home/2.png": "cc96",
	"./home/3.png": "2255",
	"./home/4.png": "bb23",
	"./home/5.png": "7546",
	"./home/6.png": "7715",
	"./home/7.png": "c4e7",
	"./home/8.png": "aa64",
	"./home/about-us-home.png": "0274",
	"./home/balkam.svg": "4a1c",
	"./home/bg.jpg": "df8f",
	"./home/caprimo.png": "dbbd",
	"./home/capsules.svg": "c8e5",
	"./home/coffee-beans.svg": "da69",
	"./home/coffee-cup.svg": "568b",
	"./home/cup.png": "f171",
	"./home/cup2.png": "863c",
	"./home/cup3.png": "54c5",
	"./home/cup4.png": "6ced",
	"./home/dropdown.jpg": "e1e8",
	"./home/factory.svg": "4a1b",
	"./home/greenIsland-small.svg": "30d9",
	"./home/investment.svg": "e83a",
	"./home/lavista.svg": "cd4b",
	"./home/logo.svg": "9bfb",
	"./home/maison-small.svg": "e09c",
	"./home/market.svg": "cd75",
	"./home/mask-group.png": "60b3",
	"./home/napoli.svg": "1254",
	"./home/private-label.svg": "4a8d",
	"./home/roaster.svg": "3901",
	"./home/s1.png": "bdcc",
	"./home/s2.png": "634b",
	"./home/s3.png": "0751",
	"./home/santos.svg": "c35f",
	"./home/spetema.svg": "0efe",
	"./home/subtraction4.svg": "f91a",
	"./home/subtraction5.svg": "4dea",
	"./home/te-small.svg": "fa03",
	"./home/vanHouten.png": "7d89",
	"./home/verdico.svg": "2d82",
	"./logo-h.svg": "40b3",
	"./logo-v.svg": "018b",
	"./marketing/address.svg": "50b3",
	"./marketing/d1.jpg": "0b76",
	"./marketing/d2.jpg": "a73b",
	"./marketing/d3.jpg": "5592",
	"./marketing/d4.jpg": "0619",
	"./marketing/email.svg": "ead4",
	"./marketing/exit.svg": "f92f",
	"./marketing/logo.svg": "14b0",
	"./marketing/map-bg-small-black.svg": "3d50",
	"./marketing/map-bg-small.svg": "bca0",
	"./marketing/map-bg.svg": "98ff",
	"./marketing/map-tr-small-orange.svg": "dd55",
	"./marketing/map-tr-small.svg": "054c",
	"./marketing/map-tr.svg": "0599",
	"./marketing/phone.svg": "3cb5",
	"./marketing/tbaza.png": "6b1e",
	"./menu-close.svg": "0335",
	"./menu-mobile.svg": "b33c",
	"./soluble-drinks/1.png": "9512",
	"./soluble-drinks/2.png": "982b",
	"./soluble-drinks/3.png": "64d2",
	"./soluble-drinks/cup.png": "c6f8",
	"./soluble-drinks/drink.png": "8c18",
	"./soluble-drinks/sol1.png": "1bf7",
	"./soluble-drinks/sol2.png": "22bf",
	"./soluble-drinks/sol3.png": "4e93",
	"./soluble-drinks/spetema.png": "ed96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";